import api from '@/helpers/api'

const API_READ=`/api/log-restful/`

export default {
  namespaced:true,
  state: {
    status: '',
    apiLog:[],
    meta:{
      page:1,
      limit:5,
      total:1
    },
    filter: {},
    tenants: [],
  },
  mutations: {
    request(state) {
      state.status = 'loading'
    },
    read(state, { apiLog }) {
      state.apiLog = [... apiLog]
    },
    error(state) {
      state.status = 'error'
    },
    success(state) {
      state.status = 'success'
    },
    switch_page(state, { meta }) {
      state.meta = { ...meta }
    },
    add_filter(state, { filter }) {
      state.filter = filter;
    },
    set_search(state, { search }) {
      state.search = { ...search };
    },
    clear_search(state) {
      state.search = {};
    },
    reset_meta(state) {
      state.meta = {
          limit: 10,
          page: 1,
          total: 1,
      }
    },
    setTenants(state, tenants) {
      state.tenants = tenants;
    }
  },
  actions: {
    read({ commit, state }) {
      commit('request');
      const { meta } = state
      const { filter } = state
      const { search } = state

      return new Promise((resolve, reject) => {
        api.request('get', API_READ, { meta, filter, search })
          .then((response) => {
            const apiLog = response.data.data;
            
            if (response.data.meta && Array.isArray(response.data.meta.tenants)) {
              commit('setTenants', response.data.meta.tenants);
            }

            commit('read', { apiLog })
            commit('success')
              
            commit('switch_page', { meta: { ...response.data.meta } })
            return resolve(apiLog)
          }).catch((err) => {
            commit('error')
            return reject(err)
          }).finally(() => {
          });
      })
    }
  },
  getters: {
    apiLog: () => state => state.apiLog,
  }
}